import { useState } from "react";
import { useGetMembersQuery } from "../../infrastructure/api/membersGroupsApi";

export const useMembers = () => {
  const [search, setSearch] = useState("");

  const { data: members = [], isLoading, isError } = useGetMembersQuery(
    search ? { query: search } : undefined,
  );

  return {
    members,
    isLoading,
    isError,
    setSearch,
  };
};
